import { render } from "./Presenze.vue?vue&type=template&id=6014c952&scoped=true&ts=true"
import script from "./Presenze.vue?vue&type=script&lang=ts"
export * from "./Presenze.vue?vue&type=script&lang=ts"

import "./Presenze.vue?vue&type=style&index=0&id=6014c952&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_mmx/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6014c952"]])

export default __exports__